import { render, staticRenderFns } from "./TextAreaComponent.vue?vue&type=template&id=994e3340&scoped=true&"
import script from "./TextAreaComponent.vue?vue&type=script&lang=js&"
export * from "./TextAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994e3340",
  null
  
)

export default component.exports